import * as z from "zod";

const ScanMatchPickLine_ = z.object({
  productTitle: z.string(),
  sku: z.string().nullable(),
  quantityRequired: z.number(),
  quantityPicked: z.number(),
});
export const ScanMatchPickLine: z.ZodType<ScanMatchPickLine> =
  ScanMatchPickLine_;
export interface ScanMatchPickLine extends z.infer<typeof ScanMatchPickLine_> {}

const ScanMatchResult_ = z.object({
  workOrderId: z.string(),
  batchId: z.string().nullable(),
  productImages: z.array(z.object({ url: z.string(), kind: z.string() })),
  flowName: z.string().nullable(),
  externalOrderName: z.string().nullable(),
  currentStepTitle: z.string().nullable(),
  status: z.string(),
  quantity: z.number(),
  matchReason: z.string(),
  bomName: z.string().nullable(),
  toteName: z.string().nullable(),
  pickLines: z.array(ScanMatchPickLine),
});
export const ScanMatchResult: z.ZodType<ScanMatchResult> = ScanMatchResult_;
export interface ScanMatchResult extends z.infer<typeof ScanMatchResult_> {}

export const searchWorkOrdersByScan = {
  name: "searchWorkOrdersByScan" as const,
  input: z.object({ barcode: z.string(), stationId: z.string().optional() }),
  output: z.object({ results: z.array(ScanMatchResult) }),
};
